/**
 * Javascript.
 * TODO : Juste garder les choses utiles.
 */


(function ($) {
	'use strict';


	// GLOBAL VARS
	var
		$body = $('body');


	// DOCUMENT READY = DOM loaded .............................................
	$(function () {
		$body.removeClass('preload'); // Page is rendered

		initSmoothScrolling(document); // Smooth scrolling on particular links
		init_carousels(); // Carousel
		// init_lightbox(); // Lightbox Lity
		// initCSSVars(); // Set CSS vars (pleine hauteur)
	});

	// WINDOW LOAD = All content loaded (DOM, content, frames, images, etc) ....
	$(window).on('load', function () {
		scrollToHash(location.hash); // Scroll to hash, if there is one.
	});



	// .........................................................................
	// SMOOTH SCROLLING ........................................................
	// .........................................................................

	function initSmoothScrolling(documentDOM) {
		// Single links
		documentDOM.querySelectorAll(".jsScroll").forEach(link => {
			link.addEventListener("click", smoothScrollTo);
		});

		// Scroll the child link
		documentDOM.querySelectorAll(".jsScrollChild > a").forEach(link => {
			link.addEventListener("click", smoothScrollTo);
		});

		// Scroll the children links
		documentDOM.querySelectorAll(".jsScrollChildren a").forEach(link => {
			link.addEventListener("click", smoothScrollTo);
		});
	}

	function smoothScrollTo(evt) {
		evt.preventDefault();

		const hash = this.getAttribute("href");
		scrollToHash(hash);
	}

	function scrollToHash(hash) {
		if (hash == '' || hash == "#") { return; }


		// Get the targetted section
		const scrollHereEl = document.querySelector(hash);

		if (scrollHereEl) {
			// responsiveOffset = 50 + (getVW() / 10), 
			// TODO : Serait cool d'avoir la hauteur de la topbar ici.
			const responsiveOffset = 0;

			// Scroll to the section
			const y = scrollHereEl.getBoundingClientRect().top + window.pageYOffset - responsiveOffset;
			window.scrollTo({ top: y, behavior: 'smooth' });
		}
	}



	// .........................................................................
	// CAROUSELS ...............................................................
	// .........................................................................

	function init_carousels() {
		carousel_images();
	}


	/**
	 * CAROUSEL / Images
	 * Images simples qui fade d'une a l'autre.
	 */
	function carousel_images() {
		var moduleName = '.jsCarouselImages';
		var $carousels = $(moduleName);
		if ($carousels.length === 0) { return; }

		$.each($carousels, function (index, element) {
			var $carousel = $(element);


			/**
			 * INIT Slick
			 */
			$carousel.slick({
				arrows:false,

				slidesToShow: 1,
				slidesToScroll: 1,

				autoplay: true, // boolean - Enables Autoplay
				autoplaySpeed: 3000, // int(ms) - Autoplay Speed in milliseconds
				pauseOnFocus: false, // boolean - Pause Autoplay On Focus
				pauseOnHover: false, // boolean - Pause Autoplay On Hover

				draggable: false, // boolean - Enable mouse dragging
				swipe: false, // boolean - Enable swiping
				touchMove: false, // boolean - Enable slide motion with touch

				fade: true, // boolean - Enable fade
				speed: 800,
			});
		});
	}



	// .........................................................................
	// LIGHTBOX LITY ...........................................................
	// .........................................................................

	// DOCS :
	// https://sorgalla.com/lity/
	// https://github.com/jsor/lity
	// https://www.jqueryscript.net/lightbox/Responsive-Modal-Plugin-jQuery-lity.html

	// Le lightbox s'active quand on ajoute data-lity sur un element.
	// Les functions ici sont donc pour ajouter des parametres au plugin.

	function init_lightbox() {
		// LITY
		// Pour une bonne utilisation du lightbox Lity :
		// Groupe AGF
		// Synagri

		// ALT : IMAGE LIGHTBOX
		// Lightbox pour galerie d'image cliquable (autre plugin) :
		// Payette, image_lightbox_projet

		// ALT : COLORBOX (autre option de lightbox)
		// Si carousel dans un colorbox, on doit faire un refresh du layout
		// du carousel quand on affiche le colorbox. Voir Sept24, fx
		// colorbox_interactive_form()
		// Custom animation on show :
		// Voir Sept24, fx colorbox_interactive_form()
		// Pour une zone de contenu (ex : share) dans un colorbox, voir
		// Exceldor, fx colorbox_video()


		/**
		 * CUSTOM lightbox
		 */
		lightbox_lity_custom();


		// Triggered before the lightbox is opened.
		$(document).on('lity:open', function (event, instance) {
			body_lock();
			// console.log('OPEN');
		});

		// Triggered when the lightbox is ready.
		// $(document).on('lity:ready', function (event, instance) {
		// 	console.log('READY');
		// });

		// Triggered before the lightbox is closed.
		$(document).on('lity:close', function (event, instance) {
			body_unlock();
			// console.log('CLOSE');
		});

		// Triggered when the closing animation is finished and just before the lightbox is removed from the DOM.
		// $(document).on('lity:remove', function (event, instance) {
		// 	console.log('REMOVE');
		// });

		// Triggered when the instance is resized, usually when the user resizes the window.
		// $(document).on('lity:resize', function (event, instance) {
		// });

		/**
		 * Ajout d'une fonctionnalite.
		 * Click sur le bouton fermer force le lightbox a fermer.
		 * Sinon, pas moyen de faire ca avec un bouton qui a du contenu a l'interieur.
		 */
		$(document).on('lity:open', function (e, instance) {
			instance.element().on('click', '[data-lity-force-close]', function () {
				instance.close();
			});
		});
	}


	/**
	 * LIGHTBOX / Lity custom
	 * On n'utilise pas data-lity pour pouvoir ajouter une classe CSS
	 * specifique au lightbox AVANT qu'il ouvre.
	 */
	function lightbox_lity_custom() {
		$(document).on('click', '.jsLightboxLityCustom', function (evt) {
			evt.preventDefault();

			var
				$trigger = $(this),
				href = $trigger.attr('href'),
				lityClass = $trigger.attr('data-lightbox-class') || '',
				lityOptions;

			// Set la classe a ajouter dans le template Lity
			lityOptions = {
				'template': '<div class="lity ' + lityClass + '" role="dialog" aria-label="Dialog Window (Press escape to close)" tabindex="-1"><div class="lity-wrap" data-lity-close role="document"><div class="lity-loader" aria-hidden="true">Loading...</div><div class="lity-container"><div class="lity-content"></div><button class="lity-close" type="button" aria-label="Close (Press escape to close)" data-lity-close>&times;</button></div></div></div>'
			}

			// Open lightbox
			lity(href, lityOptions);
		});
	}



	// .........................................................................
	// CSS VARS DEFINED IN JS ..................................................
	// .........................................................................
	let currentVW = getVW();

	function initCSSVars() {
		/**
		 * https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
		 * 
		 * Hauteur reelle du viewport.
		 * Avec ces variables, nous pouvons ajuster plus precisement
		 * la hauteur d'une section FULL HEIGHT sur mobile. C'est difficile
		 * de le faire en CSS, c'est pourquoi on cree une var en JS.
		 * 
		 * --vh :
		 * 		Update en temps reel.
		 * 		Pratique pour panel full height qui peut changer de hauteur
		 * 		car il n'influence pas les autres elements de la page
		 * 		(puisqu'il est position absolute ou fixed).
		 * 
		 * --vhDefer :
		 * 		Update seulement si la largeur change aussi.
		 * 		Pratique pour un pageHead full height dont on ne veut pas
		 * 		augmenter la hauteur au scroll (sinon la page "jump").
		 */

		document.documentElement.style.setProperty('--vh', getVH() + 'px');
		document.documentElement.style.setProperty('--vhDefer', getVH() + 'px');

		// Si on utilise la var pour Flickity : pas le choix de debouncer
		// souvent (par exemple : 10 ms), sinon ca update pas assez vite la
		// valeur pour Flickity...
		window.addEventListener('resize', _.debounce(refreshCSSVars, 250));
	}

	function refreshCSSVars() {

		/**
		 * --vh
		 * On update toujours la var --vh.
		 */
		document.documentElement.style.setProperty('--vh', getVH() + 'px');


		/**
		 * --vhDefer
		 * 
		 * PROBLEME :
		 * Si on change la hauteur de la banner quand la hauteur du viewport
		 * change, ca fait saccader car tout le contenu descend (ou monte).
		 * Ca fait bizarre quand tu consultes la page.
		 * 
		 * SOLUTION :
		 * Changer la hauteur seulement si la largeur change,
		 * donc on est certain que c'est un vrai resize, pas juste
		 * une barre de navigation qui apparait en haut de l'ecran.
		 */
		if (currentVW !== getVW()) {
			document.documentElement.style.setProperty('--vhDefer', getVH() + 'px');
			currentVW = getVW();
		}
	}



	// .........................................................................
	// VIEWPORT VARS ...........................................................
	// .........................................................................

	function getVW() {
		return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	}

	function getVH() {
		return Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	}




})(jQuery);
